var _circle, _path, _path2, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiVermelhoSlider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8569,
    cy: 10.9672,
    r: 10.2201,
    fill: "#ED291B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04643 12.1318C5.12584 11.452 5.69466 10.709 5.69466 10.709C5.69466 10.709 6.27962 11.452 6.27962 12.1318C6.27962 12.8115 4.96702 12.8115 5.04643 12.1318Z",
    fill: "#EDEFED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.009 16.5606C6.88653 16.7792 6.61007 16.8571 6.39152 16.7346C6.17297 16.6121 6.09508 16.3357 6.21756 16.1171L7.009 16.5606ZM16.1312 16.1016C16.2623 16.3151 16.1955 16.5944 15.982 16.7255C15.7685 16.8565 15.4891 16.7897 15.3581 16.5762L16.1312 16.1016ZM6.21756 16.1171C7.4198 13.9717 9.32073 12.9994 11.2349 13.071C13.1335 13.142 14.9869 14.2373 16.1312 16.1016L15.3581 16.5762C14.358 14.947 12.7699 14.0363 11.201 13.9776C9.64769 13.9195 8.05516 14.6938 7.009 16.5606L6.21756 16.1171Z",
    fill: "#FBFFFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04112,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0665,
    cy: 8.77745,
    r: 1.83605,
    fill: "#FBFFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiVermelhoSlider);
export default __webpack_public_path__ + "static/media/emojiVermelhoSlider.0ab2832b87a4c60684da292575083183.svg";
export { ForwardRef as ReactComponent };